<template>
  <div class="bg-primary-subdued rounded-xl my-16 mx-10 p-16 box-shadow-sm">
    <p class="text-grey-header text-strong-body">
      <span v-if="isBasic && isReceived && numberOfApplicants > 0">Great news–you’ve got applicants!</span>
      <span v-else-if="isBasic && isReceived">Organize Your Applicants</span>
      <span v-else-if="isInterested">Managing Applicants Tip</span>
      <span v-else>Awaiting Your Response</span>
    </p>
    <p class="text-body-2 mt-8">
      <span v-if="isBasic && isReceived && numberOfApplicants > 0">
        {{ numberOfApplicants }} quality {{ pluralize('caregiver', numberOfApplicants) }}
        {{ pluralize('is', numberOfApplicants) }} interested in your job.
        <a href="/upgrade/pricing" class="text-primary underline">Upgrade to Premium</a> to respond right away—top sitters book
        fast.
      </span>
      <span v-else-if="isBasic && isReceived">
        If received applicants don't match your needs, mark as not a fit. For those you’re excited about,
        <a href="/upgrade/pricing" class="text-grey-clickable underline">upgrade to Premium</a>
        to reply.
      </span>
      <span v-else-if="isInterested">
        All applicants you replied to will also appear in
        <router-link to="/messages" class="text-grey-clickable underline">your messages</router-link>
      </span>
      <span v-else> Be respectful and reply to all your applicants quickly to start the conversation </span>
    </p>
  </div>
</template>

<script lang="ts">
import pluralize from 'pluralize';

export default {
  name: 'ColumnTips',
  props: {
    currentTab: {
      type: String,
      required: true,
    },
    numberOfApplicants: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isBasic(): boolean {
      return this.$store.getters['account/getAccount']?.isBasic() || false;
    },
    isReceived(): boolean {
      return this.currentTab === 'RECEIVED';
    },
    isInterested(): boolean {
      return this.currentTab === 'INTERESTED';
    },
  },
  methods: {
    pluralize,
  },
};
</script>
